import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchoolImgMasterCreateRequestDTO, SchoolImgMasterDTO, SchoolImgMasterUpdateRequestDTO, SchoolImgMasterList, SchoolImgMasterDeleteRequestDTO, SchoolImgMasterReadByIdRequestDTO, SchoolImgMasterReadByMasterIdRequestDTO, SchoolImgMasterReadByMasterTypeRequestDTO } from './school-img-master.interface';
import { SchoolImgMaster_Create, SchoolImgMaster_Update, SchoolImgMaster_ReadAll, SchoolImgMaster_Delete, SchoolImgMaster_ReadById, SchoolImgMaster_ReadByMasterId, SchoolImgMaster_ReadByMasterType } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class SchoolImgMasterService {

  constructor() { }
  http = inject(HttpClient)


  SchoolImgMaster_Create(data: SchoolImgMasterCreateRequestDTO): Observable<SchoolImgMasterDTO> {
    return this.http.post<SchoolImgMasterDTO>(SchoolImgMaster_Create, data)
  }

  SchoolImgMaster_Update(data: SchoolImgMasterUpdateRequestDTO): Observable<SchoolImgMasterDTO> {
    return this.http.post<SchoolImgMasterDTO>(SchoolImgMaster_Update, data)
  }

  SchoolImgMaster_ReadAll(): Observable<SchoolImgMasterList> {
    return this.http.get<SchoolImgMasterList>(SchoolImgMaster_ReadAll)
  }
  SchoolImgMaster_Delete(data: SchoolImgMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SchoolImgMaster_Delete, data)
  }


  SchoolImgMaster_ReadById(data: SchoolImgMasterReadByIdRequestDTO): Observable<SchoolImgMasterDTO> {
    return this.http.post<SchoolImgMasterDTO>(SchoolImgMaster_ReadById, data)
  }

  SchoolImgMaster_ReadByMasterId(data: SchoolImgMasterReadByMasterIdRequestDTO): Observable<SchoolImgMasterList> {
    return this.http.post<SchoolImgMasterList>(SchoolImgMaster_ReadByMasterId, data)
  }

  SchoolImgMaster_ReadByMasterType(data: SchoolImgMasterReadByMasterTypeRequestDTO): Observable<SchoolImgMasterList> {
    return this.http.post<SchoolImgMasterList>(SchoolImgMaster_ReadByMasterType, data)
  }
}
